var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuleBasedOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1992 4.55078C12.1992 4.55078 10.5612 9.68178 9.19922 9.68178H6.96121",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1992 14.7446C12.1992 14.7446 10.5612 9.68164 9.19922 9.68164H6.96121",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 6.39648C3.874 6.39648 4.987 6.98248 4.987 7.70448C4.987 8.42648 3.873 9.01348 2.5 9.01348C1.127 9.01348 0.012 8.42648 0.012 7.70448C0.012 6.98248 1.126 6.39648 2.5 6.39648ZM0.012 10.7735V11.7735C0.455 13.5405 4.827 13.1985 4.987 11.6835V10.6835C4.769 12.3485 0.362 12.4675 0.012 10.7735ZM0 8.15848V9.13948C0.443 10.8655 4.839 10.6315 5 9.15148V8.17148C4.781 9.79648 0.35 9.81348 0 8.15848ZM0 9.42648V10.4265C0.443 12.1965 4.839 11.9585 5 10.4425V9.44248C4.781 11.1035 0.35 11.1205 0 9.42648Z",
    fill: "#272D55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6582 0C18.0322 0 19.1452 0.586 19.1452 1.308C19.1452 2.03 18.0312 2.617 16.6582 2.617C15.2852 2.617 14.1702 2.03 14.1702 1.308C14.1702 0.586 15.2842 0 16.6582 0ZM14.1702 4.377V5.377C14.6132 7.144 18.9852 6.802 19.1452 5.287V4.287C18.9272 5.952 14.5202 6.071 14.1702 4.377ZM14.1582 1.762V2.743C14.6012 4.469 18.9972 4.235 19.1582 2.755V1.775C18.9392 3.4 14.5082 3.417 14.1582 1.762ZM14.1582 3.03V4.03C14.6012 5.8 18.9972 5.562 19.1582 4.046V3.046C18.9392 4.707 14.5082 4.724 14.1582 3.03Z",
    fill: "#272D55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6582 12.9688C18.0322 12.9688 19.1452 13.5547 19.1452 14.2767C19.1452 14.9987 18.0312 15.5858 16.6582 15.5858C15.2852 15.5858 14.1702 14.9987 14.1702 14.2767C14.1702 13.5547 15.2842 12.9688 16.6582 12.9688ZM14.1702 17.3457V18.3457C14.6132 20.1128 18.9852 19.7708 19.1452 18.2558V17.2558C18.9272 18.9208 14.5202 19.0398 14.1702 17.3457ZM14.1582 14.7307V15.7118C14.6012 17.4377 18.9972 17.2038 19.1582 15.7238V14.7437C18.9392 16.3688 14.5082 16.3857 14.1582 14.7307ZM14.1582 15.9987V16.9988C14.6012 18.7688 18.9972 18.5308 19.1582 17.0148V16.0148C18.9392 17.6757 14.5082 17.6927 14.1582 15.9987Z",
    fill: "#272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuleBasedOperationIcon);
export default __webpack_public_path__ + "static/media/RuleBasedOperationIcon.a8e70525efc3165b5f41c59aeaff9018.svg";
export { ForwardRef as ReactComponent };